import {
  CssBaseline,
  Box,
  Grid,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const headers = {
  headers: { "Content-Type": "application/json", Accept: "application/json" },
};

const theme = createTheme();

export default function PaymentsPage() {
  const { t } = useTranslation();

  const styles = {
    title: {
      color: "#3657D9",
      fontFamily: "Poppins",
      fontSize: "22px",
      fontWeight: "700",
      lineHeight: "26px",
      textAlign: "center",
    },
    text: {
      color: "#575565",
      fontSize: "16px",
      whiteSpace: "pre-line",
    },
    container: {
      minWidth: "200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      alignSelf: "center",
      justifyItems: "center",
    },
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        component="main"
        sx={{height: "100vh" }}
      >
        <CssBaseline />
        <Grid item xs={12} sx={{ alignContent: "center", alignItems: "center"}}>
          <Box sx={styles.container}>
            <img src="logo.png" alt="logo" width={320} />
            <Box sx={{ mt: "64px" }}>
              <Box sx={[styles.title, { mb: "20px" }]}>
                {t("payment_successful")}
              </Box>
              <Box sx={[styles.title, { mb: "20px" }]}>
                {t("restart_app")}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
